<template>
  <div v-if="sales" class="p-0 col-12 animated fadeIn">
    <div id="accordion">
      <div class="card">
        <div class="card-header" id="headingOne">
          <h5 class="mb-0">
            <button class="btn" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" 
                aria-controls="collapseOne" style="background: transparent !important">
              {{sales.order_code}} / {{sales.customer.name}} / {{sales.logistic.toUpperCase()}}
            </button>
          </h5>
        </div>
        <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
          <div class="card-body">
            <div class="row m-0">
              <div class="col-6 col-md-3 p-0">Sales Person</div>
              <div class="col-6 col-md-3 p-0 value-field">
                <span class="text-capitalize">{{sales.cs_detail.fullname}}</span>
              </div>
              <div class="col-6 col-md-3 p-0">Sales Type</div><div class="col-6 col-md-3 p-0 value-field">
                <span class="text-uppercase">{{sales.type}}</span>
              </div>
              <div class="col-6 col-md-3 p-0">Channel</div>
              <div class="col-6 col-md-3 p-0 value-field">
                <span class="text-uppercase">{{sales.channel}}</span>
              </div>
              <div class="col-6 col-md-3 p-0">Logistic</div>
              <div class="col-6 col-md-3 p-0 value-field">
                <span class="text-uppercase">{{sales.logistic}}</span>
              </div>
              <hr class="col-12"/>
              <div class="col-12 col-md-6 p-0">
                <table style="width: 100%; border: none">
                  <tr>
                    <td class="px-1 py-2 text-capitalize" width="50%">Customer Name</td>
                    <td class="px-1 py-2 text-capitalize" style="border: none">{{ sales.customer.name.toLowerCase() }}</td>
                  </tr>
                  <tr>
                    <td class="px-1 py-2 text-capitalize">Phone Number</td>
                    <td class="px-1 py-2" style="border: none">{{ sales.customer.phone }}</td>
                  </tr>
                  <tr>
                    <td class="px-1 py-2 text-capitalize">Email</td>
                    <td class="px-1 py-2" style="border: none" v-if="sales.customer.email">{{sales.customer.email}}</td>
                    <td class="px-1 py-2" style="border: none" v-else>-</td>
                  </tr>
                  <tr>
                    <td class="px-1 py-2 text-capitalize">Address</td>
                    <td class="px-1 py-2 text-capitalize" style="border: none">{{ sales.customer.address.toLowerCase() }}<br/>({{ sales.customer.notes }})</td>
                  </tr>
                  <tr>
                    <td class="px-1 py-2 text-capitalize">Bank Account</td>
                    <td class="px-1 py-2 text-capitalize" style="border: none">{{ sales.account_name.toLowerCase() }}</td>
                  </tr>
                  <tr>
                    <td class="px-1 py-2 text-capitalize">Payment Time</td>
                    <td class="px-1 py-2 text-capitalize" style="border: none"> {{ sales.payment_time }} </td>
                  </tr>
                </table>
              </div>
              <hr class="col-12 d-md-none"/>
              <div class="col-12 col-md-6 p-0">
                <table style="width: 100%; border: none">
                  <tr v-for="(cart, index) in sales.cart" :key="index">
                    <td class="px-1 py-2 text-capitalize" width="50%"> {{ cart.product.name.toLowerCase() }}<strong>{{cart.qty}}</strong> {{ cart.product.unit }}</td>
                    <td class="px-1 py-2" style="border: none">{{ kendo.toString(cart.product.price * cart.qty, 'c') }}</td>
                  </tr>
                  <tr>
                    <td class="px-1 py-2 text-capitalize">Shipping Cost</td>
                    <td class="px-1 py-2" style="border: none">{{ kendo.toString(sales.cost.shipment, 'c') }}</td>
                  </tr>
                  <tr>
                    <td class="px-1 py-2 text-capitalize">Total Discount</td>
                    <td class="px-1 py-2" style="border: none">{{ kendo.toString(Number(sales.discounts), 'c') }}</td>
                  </tr>
                </table>
              </div>
              <hr class="col-12"/>
              <div class="col-6 offset-0 col-md-3 offset-md-6 p-0 text-uppercase"><strong>Final Price</strong></div>
              <div class="col-6 col-md-3 p-0">
                <strong>{{ kendo.toString(Number(sales.price), 'c') }}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 p-0" style="margin-bottom: 10px;" v-bind:class="{ 'd-none': !verification.item }">
      <span class="form-feedback error">Items must be with the exact quantity before submitting</span>
    </div>
    <div v-for="(cart, idx) in items" :key="cart.product.code" class="card">
    <div class="card-header">
        <span>Items for <span class="text-capitalize">{{cart.product.name.toLowerCase()}} {{cart.qty}} </span><span>{{cart.product.unit.toLowerCase()}}</span></span>
      </div>
      <div class="card-body">
        <div class="form-horizontal">
          <div class="row form-group">
            <!-- <label class="col-6 col-md-4 col-lg-3">Barcode Type</label> -->
            <div class="col-12">
              <kendo-switch :on-label="'UNIVERSAL'" :off-label="'SEPARATE'" v-model="cart.universal" @change="typeChange($event, idx)" v-bind:disabled="cart.isFull || cart.items.length > 0"></kendo-switch>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-12">
              <input id="input-codes" placeholder="Item Barcode" class="form-control" 
                v-on:keypress="tagInput($event, idx)" :value="itemStr"
                v-bind:disabled="cart.isFull"/>
            </div>
            <div class="col-12 items" style="margin-top: 10px">
              <span class="d-inline-block" v-for="(item, index) in cart.items" :key="index" v-bind:class="{ 'accepted': item.uid, 'invalid': !item.isValid }">
                {{item.code.toUpperCase()}}&nbsp;&nbsp;
                <i class="fa fa-trash-alt" @click="removeItem($event, idx, index)"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <h5 class="mb-0">
          <button class="btn" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" 
              aria-controls="collapseTwo" style="background: transparent !important">
            Resources Form
          </button>
        </h5>
      </div>
      <div id="collapseTwo" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
        <div class="card-body">
          <div class="form-horizontal">
            <div class="form-group row" v-for="(resource, index) in packing.resources" :key="index">
              <label class="col-6 col-md-4 col-lg-3">{{resource.name}}</label>
              <div class="col-6 col-md-8 col-lg-9">
                <numeric-text-box :min="0" :format="'n0'" culture="id-ID" class="form-control" 
                    :placeholder="resource.dimension + ' ' + resource.name"
                    @change="usageChange($event, index)"
                    :value="resource.usage" v-bind:disabled="!validateForm()"></numeric-text-box>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer text-right">
          <button class="btn btn-primary" @click="submit" v-bind:disabled="!validateForm()"><i class="fa fa-save"></i>&nbsp;SUBMIT</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { NumericTextBox } from '@progress/kendo-inputs-vue-wrapper'
import InputTag from 'vue-input-tag'

export default {
  data () {
    return {
      // data here
      kendo: window.kendo,
      sales: null,
      resources: [],
      items: [],
      itemStr: '',
      tempItem: '',
      quantity: 0,
      currentResource: [],
      packing: {
        uid: null,
        tempUid: null,
        resources: []
      },
      verification: {
        items: true,
        resources: true
      }
    }
  },
  components: {
    NumericTextBox,
    InputTag
  },
  created () {
    // set culture
    window.kendo.culture('id-ID')
    // get sales data
    this.getSalesData()
  },
  methods: {
    getSalesData () {
      var uid = this.$route.params.uid
      var vm = this
      vm.axios.get('api/sales/logs/' + uid + '/')
        .then(
          (response) => {
            var data = response.data
            vm.sales = data
            for (var i = 0; i < vm.sales.cart.length; i++) {
              vm.sales.cart[i].items = []
              vm.sales.cart[i].isFull = false
              var item = {
                product: vm.sales.cart[i].product,
                isFull: false,
                qty: vm.sales.cart[i].qty,
                items: [],
                universal: false
              }
              vm.items.push(item)
            }
            vm.getItems()
            vm.getResources()
          }
        )
        .catch(
          (error) => {
            console.log(error)
            vm.$router.push('Four Oh Four')
          }
        )
    },
    getItems () {
      var vm = this
      vm.axios.get('api/inventory/packaging/items/?sales=' + vm.sales.uid)
        .then(
          (response) => {
            var data = response.data
            for (var i = 0; i < data.length; i++) {
              var item = data[i]
              for (var ii = 0; ii < vm.items.length; ii++) {
                if (item.product_code === vm.items[ii].product.code) {
                  vm.items[ii].items.push(item)
                  if (vm.items[ii].items.length === vm.items[ii].qty) {
                    vm.items[ii].isFull = true
                  }
                  break
                }
              }
            }
          }
        )
        .catch(
          (error) => {
            console.log(error)
          }
        )
    },
    getResources () {
      var vm = this
      vm.axios.get('api/inventory/package/resources/')
        .then(
          (response) => {
            vm.resources = response.data
            var currentData = []
            if (vm.sales.packing.length > 0) {
              currentData = vm.sales.packing[0].resources
            }
            for (var i = 0; i < vm.resources.length; i++) {
              var usage = 0
              for (var ii = 0; ii < currentData.length; ii++) {
                if (vm.resources[i].name.toUpperCase() === currentData[ii].name.toUpperCase()) {
                  usage = currentData[ii].usage
                }
              }
              var resource = {
                name: vm.resources[i].name,
                dimension: vm.resources[i].dimension,
                unit: vm.resources[i].unit,
                usage: parseInt(usage)
              }
              vm.packing.resources.push(resource)
            }
          }
        )
    },
    usageChange (event, index) {
      this.packing.resources[index].usage = event.sender.value()
      console.log(this.packing)
    },
    typeChange (event, index) {
      this.items[index].universal = event.sender.value()
      console.log(this.items[index])
    },
    tagInput (event, cart) {
      if (event.keyCode === 13 || event.keyCode === 32 || event.keyCode === 44) {
        // do separation
        var loop = 1
        if (this.items[cart].universal) {
          loop = this.sales.cart[cart].qty
        }
        var item = {
          uid: null,
          code: this.tempItem.toUpperCase(),
          isValid: true
        }
        this.submitItem(cart, item, loop)

        this.itemStr = ''
        this.tempItem = ''
      } else {
        this.tempItem += event.key
      }
      return true
    },
    submitItem (cart, item, loop) {
      console.log(loop)
      this.items[cart].items.push(item)
      var index = this.items[cart].items.length - 1
      var formData = new URLSearchParams()
      formData.append('sales', this.sales.uid)
      formData.append('product', this.items[cart].product.code)
      formData.append('item', item.code.toUpperCase())
      var vm = this
      vm.axios.post('api/inventory/packaging/item/', formData)
        .then(
          (response) => {
            if (response.status === 200) {
              var data = response.data
              vm.items[cart].items[index].uid = data.uid
              vm.items[cart].isFull = vm.items[cart].items.length === parseInt(vm.sales.cart[cart].qty, 10)
              vm.items[cart].items[index].isValid = true
              vm.items[cart].items[index].isValid = true
              if (loop > 1) {
                loop -= 1
                vm.submitItem(cart, item, loop)
              }
            } else {
              var message = response.data.message
              vm.$parent.showNotification(message, 'error')
              if (vm.items[cart].universal) {
                vm.items[cart].items = []
              } else {
                vm.items[cart].items.splice(index, 1)
              }
            }
          }
        )
        .catch(
          (error) => {
            console.log(error)
            vm.$parent.showNotification('Invalid Item Barcode ' + vm.items[cart].items[index].code.toUpperCase(), 'error')
            if (vm.items[cart].universal) {
              vm.items[cart].items = []
            } else {
              vm.items[cart].items.splice(index, 1)
            }
          }
        )
    },
    removeItem (event, cart, index) {
      var vm = this
      var item = this.items[cart].items[index]
      window.$.confirm({
        theme: 'material',
        icon: 'fa fa-question',
        columnClass: 'col-12 col-md-8 col-md-offset-2',
        animateFromElement: false,
        animation: 'bottom',
        title: 'Confirm Item Removal',
        content: 'Are you sure you want to remove item <span style="font-weight: bold">' + item.code.toUpperCase() + '</span> from packing ?',
        buttons: {
          cancel: {
            text: 'No, Don\'t Remove',
            btnClass: 'btn-outline-danger',
            action: function () {
              // do nothing
            }
          },
          confirm: {
            text: 'Yes, Remove Item',
            btnClass: 'btn-outline-success',
            action: function () {
              if (vm.items[cart].items[index].uid) {
                // remove from cart
                vm.axios.delete('api/inventory/packaging/items/remove/?item=' + vm.items[cart].items[index].uid + '&sales=' + vm.sales.uid)
                  .then(
                    (response) => {
                      vm.items[cart].items.splice(index, 1)
                      vm.items[cart].isFull = false
                    }
                  )
                  .catch(
                    (error) => {
                      console.log(error.response)
                      vm.$parent.showNotification('Oops! Unable to remove data at this moment. Please try again later!', 'danger')
                    }
                  )
              } else {
                vm.items[cart].items.splice(index, 1)
                vm.items[cart].isFull = false
              }
            }
          }
        }
      })
    },
    submit () {
      // validate form first
      if (this.validateForm()) {
        // actual submission here
        var vm = this
        var data = new URLSearchParams()
        data.append('resources', JSON.stringify(vm.packing.resources))
        data.append('sales', vm.sales.uid)
        vm.axios.post('api/inventory/packaging/', data)
          .then(
            (response) => {
              console.log(response)
              vm.$parent.showNotification('Packing Updated for Sales ' + vm.sales.order_code, 'success')
              var page = 1
              if ('return' in vm.$route.query) {
                page = vm.$route.query.return
              }
              vm.$router.push('/sales?page=' + page)
            }
          )
          .catch(
            (error) => {
              console.log(error.response)
              vm.$parent.showNotification('Oops! Unable to submit data at this moment. Please try again later!', 'danger')
            }
          )
      }
    },
    validateForm () {
      // do validation here
      for (var i = 0; i < this.items.length; i++) {
        if (!this.items[i].isFull) {
          this.verification.items = false
          return false
        }
      }
      this.verification.items = true
      return true
    }
  }
}
</script>

<style scoped>
  .items > span {
    padding: 5px;
    margin-right: 5px;
    background: #EAEAEA;
  }
  .items > span > .fa {
    font-weight: lighter;
    cursor: pointer;
    color: #636363;
  }
  .items > span > .fa:hover {
    color: #212121;
  }
  .items > span.invalid {
    border: solid 1px red;
    background: transparent !important;
  }
  .items > span.invalid > .fa {
    color: red !important;
  }

  .items > span.accepted {
    border: solid 1px green;
    background: transparent !important;
  }
  .items > span.accepted > .fa {
    color: green !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/packing/Packing.vue